<template>
  <div class="garanties-list my-account-wrapper">
    <div class="clients__title">
      RIB
      <p class="sub-title">Votre Relevé d’Identité Bancaire</p>
    </div>

    <template v-if="isLoading">
      <Preloader />
    </template>
    <template v-else>
      <div class="garanties-filter">
        <div class="garanties-filter--wrap">
          <div class="garanties-filter__fields">
            <ImportRIBFileInput
              v-model="document.file"
              :options="document.options"
              :allowedFileExtensions="document.allowedFileExtensions"
              @verification_documents_uploaded="onDocumentUploaded"
              :disabled="isMultiFileInputDisabled"
            />

            <div
              class="garanties-filter__fields block__content--table docs-table"
              style="margin-top: 20px"
            >
              <table>
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Nom du fichier</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="doc in docs" :key="doc.hash">
                    <td class="created">{{ formatDate(doc.created_at) }}</td>
                    <td
                      @click="openPreviewDocument(doc.hash, doc.type)"
                      class="preview-document-link"
                    >
                      {{ doc.name }}
                    </td>
                    <td>{{ formatDocStatus(doc.status) }}</td>
                    <td>
                    <font-awesome-icon
                      prefix="fas"
                      icon="trash"
                      @click="doc.status !== 'approved' && removeDocument(doc.id)"
                      :class="{ disabled: doc.status === 'approved' }"
                    />
                  </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="custom-filter__buttons">
              <button
                class="custom-filter__buttons--button"
                @click="goToDocuments"
              >
                Fermer
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Preloader from "@/components/Preloader";
import ImportRIBFileInput from "./ImportRIBFileInput";
import formats from "@/mixins/formats";

export default {
  name: "RIBImport",
  components: { ImportRIBFileInput, Preloader },
  mixins: [formats],
  data() {
    return {
      document: {
        type: "IMPORT_RIB",
        title: "",
        file: [],
        options: {
          name: "Choisir un document",
          placeholder: true,
          currentFile: false,
          hash: null,
        },
        allowedFileExtensions:
          "image/jpeg, image/jpg, image/png, image/gif, application/pdf",
      },
      isLoading: false,
      status: "pending",
      docs: [],
      currentDocumentType: "rib",
    };
  },
  computed: {
    isApproved() {
      return this.status === "approved";
    },
    isMultiFileInputDisabled() {
      // Check if all documents are approved
      return this.docs.length ? this.docs.every(doc => doc.status === 'approved') : 0;
    },
  },
  watch: {
    "$store.getters.getAuthUserInfo": function (user) {},
  },
  methods: {
    getRepresentativeInfo(id) {
      this.isBusy = true;
      let url = `verification_documents/all-documents/${id}`;
      this.apiGet(url)
        .then((response) => {
          this.isBusy = false;
          let docs = response.data.documents || [];
          this.docs = docs.filter(
            (item) => item.type_name === this.currentDocumentType
          );
        })
        .catch((error) => {
          this.isBusy = false;
          this.showErrorNotification(error);
        });
    },
    onDocumentUploaded(data) {
      if (
        data.verification_documents &&
        data.verification_documents.length > 0
      ) {
        data.verification_documents.forEach((doc) => {
          this.docs.push(doc); // Add each new document to the list
        });
        this.document.file = [];
      }
    },
    openPreviewDocument(hash, type) {
      this.isBusy = true;
      let url = "verification_documents/file-preview";
      this.apiGet(url, {
        hash: hash,
        type: type,
      })
        .then((response) => {
          this.isBusy = false;
          console.log(response);
          if (response.data && response.data.url) {
            window.open(response.data.url);
          }
        })
        .catch((error) => {
          this.isBusy = false;
          this.showErrorNotification(error);
        });
    },
    goToDocuments() {
      this.$router.push(`/my-documents`);
    },
    removeDocument(id) {
      this.$confirm({
        message: "Êtes-vous sûr de vouloir supprimer ce document ?",
        button: {
          no: "NON",
          yes: "OUI",
        },
        /**
         * Callback Function
         * @param {Boolean} confirm
         */
        callback: (confirm) => {
          if (confirm) {
            let url = `verification_documents/delete/${id}`;
            this.apiDelete(url)
              .then((response) => {
                const index = this.docs.findIndex(doc => doc.id === id);
                if (index !== -1) {
                  this.docs.splice(index, 1);
                }
                this.showSuccessNotification("Document supprimé avec succès");
              })
              .catch((error) => {
                this.isBusy = false;
                this.showErrorNotification(error);
              });
          }
        },
      });
    },
  },
  mounted() {
    this.user = this.$store.getters.getAuthUserInfo;
    this.getRepresentativeInfo(this.user.representative.id);
  },
};
</script>
<style>
.sub-title {
  font-size: 12px;
}
.disabled {
  pointer-events: stroke; /* Disables pointer actions (no click) */
  opacity: 0.5;         /* Makes it look grayed out */
  cursor: not-allowed !important;  /* Shows a disabled cursor */
}
</style>



// WEBPACK FOOTER //
// src/components/Documents/RIBImport.vue